<template>
<div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>

    <basic-table
        v-if="tv24Tariffs"
        :items="tv24Tariffs"
        :fields="fields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        :isDelete="false"
        :isEdit="false"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
</div>
</template>

<script>
export default {
  data () {
    return {
      fields: [
        {key: 'id', label: '24TV ID', sortable: true},
        {key: 'name', label: 'name', sortable: true},
        {key: 'price', label: 'price', sortable: true},
        {key: 'base', label: 'base', sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'available_tariffs',
          label: 'Available tariffs',
          sortable: true,
          formatter: (val, key, item) => {
            return item.available ? item.available.length : 0
          }}
      ],
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      options: {
        isShowAddButton: false
      }
    }
  },
  methods: {

    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    tv24Tariffs () {
      return this.$store.getters['Settings/TV_24_AVAILABLE_TARIFFS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_TV_24_AVAILABLE_TARIFFS')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/tariffs.vue